export default "__VITE_ASSET__cUzGh5SU__"